import React, { ReactNode } from 'react';

import { Box, Button } from '@mui/material';
import { JBIcon, JBTypography } from '@juliusbaer-gcrm/gcrm-frontend-components';

type Props = {
  buttonText: string;
  buttonAction: () => void;
  icon: ReactNode;
  description: string;
  isLoading: boolean;
  id: string;
  disabled: boolean;
  testId?: string;
};

const CreateNewEntityButton = ({ buttonText, buttonAction, icon, description, id, disabled, testId }: Props) => {
  return (
    <Box display="flex" justifyContent="space-between" bgcolor="white" p={3}>
      <Box display="flex" alignItems="center">
        <Box pr={1}>{icon}</Box>
        <Box>
          <JBTypography variant="h4">{description}</JBTypography>
        </Box>
      </Box>

      <Button
        id={id}
        data-testid={testId}
        disabled={disabled}
        startIcon={<JBIcon iconName={disabled ? 'cancelled' : 'addOutline'} />}
        onClick={() => buttonAction()}
        variant="outlined"
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default CreateNewEntityButton;
